/** `sidebar`: accordions beside the grid. `row`: dropdowns in the toolbar row. */
export type ListingFiltersLayout = "sidebar" | "row";

export interface ListingFiltersConfig {
	groupPriceThousands: boolean;
	layout: ListingFiltersLayout;
	/**
	 * Filter groups to show first, in this order (`brands`, `category`,
	 * `price`, `stock`, `flags`, `color`, or `parametrics` for every parametric
	 * group); the rest follow in Norce's order. Empty = Norce's order.
	 */
	sectionOrder: string[];
	/** Sidebar groups open on load (same names); selected groups always are. */
	openSections: string[];
}

declare module "nuxt/schema" {
	interface AppConfigInput {
		/** Per-template listing filter switches; see `useListingFiltersConfig`. */
		listingFilters?: Partial<ListingFiltersConfig>;
	}
	interface AppConfig {
		listingFilters?: Partial<ListingFiltersConfig>;
	}
}

const DEFAULT_LISTING_FILTERS_CONFIG: ListingFiltersConfig = {
	groupPriceThousands: false,
	layout: "sidebar",
	sectionOrder: [],
	openSections: []
};

/**
 * Per-template listing filter switches from `app.config.ts` (`listingFilters`),
 * with defaults for templates that set nothing (or set a switch to undefined).
 */
export const useListingFiltersConfig = (): ListingFiltersConfig => {
	const { listingFilters } = useAppConfig();
	return {
		groupPriceThousands:
			listingFilters?.groupPriceThousands ??
			DEFAULT_LISTING_FILTERS_CONFIG.groupPriceThousands,
		layout: listingFilters?.layout ?? DEFAULT_LISTING_FILTERS_CONFIG.layout,
		sectionOrder:
			listingFilters?.sectionOrder ??
			DEFAULT_LISTING_FILTERS_CONFIG.sectionOrder,
		openSections:
			listingFilters?.openSections ??
			DEFAULT_LISTING_FILTERS_CONFIG.openSections
	};
};
